// extracted by css-extract-rspack-plugin
export default {"vacancyHintContent":"vacancy-hint-content--Ti1dmYc2hJwhiWHA"};